import React, { useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import IframeWeb from './IframeWeb'


const InDevelopment = () => {

    return (
        // <div className='wrapper' style={{ marginTop: '6.5rem' }}>
        //     <IframeWeb height="750" source="https://trampolinehealth.circle.so/home" />
        // </div>
        <div className='wrapper' style={{ marginTop: '6.5rem', marginLeft: '1.5rem', marginRight:' 1.5rem' }}>
            <div>
                <h2 className="text-center">  Making Improvements, Please Stand By ⚙️🔨👨‍💻 </h2>
            </div>
        </div>
)
}


export default InDevelopment;